import {
  BaseIcon
} from "./chunk-Z3LMOCJ7.mjs";

// src/icons/tokens/TokenUSDT.tsx
import { forwardRef } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var TokenUSDT = forwardRef(
  ({ variant = "mono", ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { ...props, ref, children: variant === "mono" ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12 20 2 10.135 5.815 4h12.37L22 10.135zm1-9V9.78c1.8.09 3.48.44 4 .895-.605.53-2.77.915-5 .915s-4.395-.385-5-.915c.515-.455 2.2-.8 4-.9V11zm-6-.33v.735c.515.455 2.195.8 4 .9V15h2v-2.7c1.8-.09 3.485-.44 4-.895V9.94c-.515-.455-2.2-.805-4-.9V8h3V6.5H8V8h3v1.04c-1.805.095-3.485.445-4 .9z"
    }
  ) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "#009393",
      d: "M12 20 2 10.135 5.815 4h12.37L22 10.135zm1-9V9.78c1.8.09 3.48.44 4 .895-.605.53-2.77.915-5 .915s-4.395-.385-5-.915c.515-.455 2.2-.8 4-.9V11zm-6-.33v.735c.515.455 2.195.8 4 .9V15h2v-2.7c1.8-.09 3.485-.44 4-.895V9.94c-.515-.455-2.2-.805-4-.9V8h3V6.5H8V8h3v1.04c-1.805.095-3.485.445-4 .9z"
    }
  ) }) })
);
TokenUSDT.displayName = "USDT";
var TokenUSDT_default = TokenUSDT;

export {
  TokenUSDT_default
};
